// import { DetailSupportFormEntrepreneurContainer } from "../../../containers/SupportSystem/SupportForm/DetailSupportFormEntrepreneurContainer";
import { DetailInnovationPersonTrainAndExpectedContainer } from "../../../containers/SupportSystem/SupportForm/DetailInnovationPersonTrainAndExpectedContainer";
export function DetailInnovationPersonTrainAndExpectedPage() {
    return (
        <DetailInnovationPersonTrainAndExpectedContainer/>
    );

}